import Layout from "../../components/Layout";

function About() {
    return (<Layout>
    </Layout>);
}

export default About;